/** Kwota w jednostkach podrzędnych waluty: groszach, centach. Zawsze całkowita. */
export type Minor = number

/**
 * Zaokrąglenie bankierskie (half-to-even). Przy dokładnej połówce wybiera
 * liczbę parzystą, dzięki czemu wielokrotne dzielenia nie kumulują błędu
 * w jedną stronę.
 */
export function roundHalfEven(value: number): number {
  const lower = Math.floor(value)
  const fraction = value - lower
  if (fraction > 0.5) return lower + 1
  if (fraction < 0.5) return lower
  return lower % 2 === 0 ? lower : lower + 1
}

export function divideMinor(amount: Minor, divisor: number): Minor {
  if (divisor === 0) throw new Error('Dzielenie przez zero')
  return roundHalfEven(amount / divisor)
}

export function applyRate(amount: Minor, rate: number): Minor {
  return roundHalfEven(amount * rate)
}

export function sumMinor(values: readonly Minor[]): Minor {
  let total = 0
  for (const value of values) total += value
  return total
}

export function netFromGross(gross: Minor, vatRatePercent: number): Minor {
  if (vatRatePercent === 0) return gross
  return roundHalfEven(gross / (1 + vatRatePercent / 100))
}

const AMOUNT_PATTERN = /^-?\d+(?:[.,]\d+)?$/

export function parseAmount(input: string): Minor {
  const cleaned = input.replace(/[\s  ]/g, '')
  if (!AMOUNT_PATTERN.test(cleaned)) {
    throw new Error(`Nieprawidłowa kwota: ${input}`)
  }
  const normalized = cleaned.replace(',', '.')
  return roundHalfEven(Number(normalized) * 100)
}

export function formatMinor(amount: Minor, currency: string): string {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount / 100)
}
